import React from 'react'
import getTransitionStyle from '../utils/getTransitionStyle'
import Transition from 'react-transition-group/Transition'
import Link from '../components/IntlLink'
import uniqBy from 'lodash.uniqby'
import { FormattedMessage } from 'react-intl'

class HomeOverlay extends React.Component {
  constructor(props) {
    super(props)
    this.state = { show: false }
  }

  renderCollectionSlide(slide, state) {
    const allDesigners = uniqBy(
      slide.collection.combos.reduce((acc, combo) => (
        acc.concat(
          combo.baseBits
            .map(bit => bit.designer)
            .filter(x => !!x)
            .concat(
              combo.optionalBits
              .map(bit => bit.designer)
              .filter(x => !!x)
            )
        )
      ), []),
      'name'
    )

    const timeout = 200
    const {delay} = this.props
    const status = this.props.transition ? this.props.transition.status : "entering"

    const subtitleAppear = getTransitionStyle(
      status, timeout, delay + 300, 'homeOverlay'
    )

    const opacity = getTransitionStyle(
      status, 200, 0, 'opacityOut'
    )

    const subtitleAppearOnSlideChange = getTransitionStyle(
      state, 150, 100, 'homeOverlay'
    )

    const titleAppear = getTransitionStyle(
      status, timeout, delay + 600, 'homeOverlay'
    )

    const titleAppearOnSlideChange = getTransitionStyle(
      state, 150, 0, 'homeOverlay'
    )

    const overlaySlideStyle = getTransitionStyle(
      status, 500, delay, 'overlaySlideStyle', 0
    )

    return (
      <div className="page--home" >
        <div className="page--home"style={overlaySlideStyle}>
          <div className="page__title--home" style={titleAppear}>
            <div style={titleAppearOnSlideChange}>
              {slide.slideTitle}
            </div>
          </div>
          <div className="page__text--home" style={subtitleAppear}>
            <div style={subtitleAppearOnSlideChange}>
              <FormattedMessage id="home.collection" />
            </div>
          </div>
        </div>
        <Link
          style={{...opacity, backgroundColor: slide.collection.color.hex}}
          className="button--red slider--home__link"
          to={`/collection/${slide.collection.slug}`}
        >
          <FormattedMessage
            id="home.discoverCollection"
            values={{ name: slide.slideTitle }}
          />
        </Link>
      </div>
    )
  }

  renderCustomSlide(slide, state, timeout) {
    return(
      <div className="page--home" style={{ ...this.getTransitionStyle(timeout, 0)[state], ...this.getTransitionStyle(600, 0)[this.props.parentStatus] }}>
        <div className="page__title--home" style={{ ...this.getTransitionStyle(timeout, 0)[state]}}>
          { slide.slideTitle }
        </div>
        {
          slide.buttonText && slide.link &&
            <a
              style={{ ...this.getTransitionStyle(timeout, 0)[state], backgroundColor: slide.color.hex }}
              className="button--red slider--home__link"
              href={slide.link}
              target="_blank"
            > { slide.buttonText } </a>
        }
      </div>
    )
  }

  render(){
    const timeout = 200

    const {slide} = this.props

    return (
      <Transition in={!!this.props.show} timeout={timeout}>
        {(state) => (
          slide.collection ?
            this.renderCollectionSlide(slide, state) :
            this.renderCustomSlide(slide, state)

        )}
      </Transition>
    )
  }
}

export default HomeOverlay



// WEBPACK FOOTER //
// ./src/components/HomeOverlay.js